import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { applyStudioTheme, clearInlineTheme } from './applyTheme'
import {
  getStoredMerchantId,
  isThemeOn,
  persistScanTheme,
  persistThemeFromSearch,
} from './themeGate'

function isScanPath(pathname: string): boolean {
  return pathname.startsWith('/scan/') || pathname.startsWith('/merchant/')
}

export function useApplyStudioTheme(): void {
  const location = useLocation()

  useEffect(() => {
    const search = new URLSearchParams(location.search)
    if (isScanPath(location.pathname)) {
      const pathHq = location.pathname.match(/^\/merchant\/([^/]+)/)?.[1]
      persistScanTheme(search, pathHq)
    } else {
      persistThemeFromSearch(search)
    }

    if (!isThemeOn(search)) {
      clearInlineTheme()
      return
    }

    const pathMerchantId = getStoredMerchantId()
    if (!pathMerchantId) return

    const ac = new AbortController()
    applyStudioTheme(pathMerchantId, ac.signal)
    return () => ac.abort()
  }, [location.pathname, location.search])
}
